import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo, useCallback } from 'react';
import cls from 'classnames';
import styles from './FancyTextArea.less';
export const ERROR = 'error';
export const SUCCESS = 'success';
const CLASS_APPEARANCE_MAP = {
    [ERROR]: styles.fancyTextAreaError,
    [SUCCESS]: styles.fancyTextAreaSuccess,
};
export function FancyTextArea(props) {
    const { onChange, name = '', className, appearance, value, disabled = false, placeholder = '', ...rest } = props;
    const handleChange = useCallback((e) => onChange?.(e.target.value, e), [onChange]);
    return (_jsx("textarea", { className: cls(styles.fancyTextArea, { [styles.fancyTextAreaDisabled]: disabled }, appearance && CLASS_APPEARANCE_MAP[appearance], className), disabled: disabled, name: name, onChange: handleChange, placeholder: placeholder, value: value ?? '', ...rest }));
}
export default memo(FancyTextArea);
